import type { QueryRequestFilters } from '@moment/horizon-data-access/platform'

/** One side of the order book, as Security names it in `best_{side}_*`. */
export type QuoteSideKey = 'bid' | 'ask'

/** A wire SORM `where` over `Security`, keyed by `Security.<field>`. */
export type SecurityWhere = QueryRequestFilters

/** A Security row keyed by bare field name or computed-column alias. */
export type SecurityRow = Record<string, unknown>

/** Raised when a filter or objective has no Security translation. */
export class UnsupportedSecurityTranslationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'UnsupportedSecurityTranslationError'
  }
}
